export default __webpack_public_path__ + "static/media/ic_isle_of_man.467f1141.svg";